import { cva } from "class-variance-authority";

export { default as Drawer } from "./Drawer.vue";

export const contentVariants = cva(
    "flex flex-col max-h-3/4 [&>div]:pt-4 [&>div]:px-4 [&>div:last-of-type]:pb-4 [&>div]:border-secondary overflow-hidden",
    {
        variants: {
            variant: {
                default: "",
                full: "h-screen max-h-[90vh]",
                auto: "max-h-max",
                filters:
                    "h-screen [&>div]:pt-0 [&>div:first-of-type]:pt-4 [&_#footer]:pt-4 [&>div:first-of-type]:pb-1 [&>div:first-of-type]:bg-utility-gray-50 [&>div:first-of-type]:border-b [&>div:nth-of-type(2)]:pb-0",
                upload: "h-full max-h-[96vh]",
                details:
                    "h-full max-h-[96vh] [&>div]:pt-6 [&>div:nth-of-type(2)]:order-first [&>div:nth-of-type(2)]:py-0 [&>div:nth-of-type(2)]:pl-5 [&>div:nth-of-type(2)]:pr-12 [&>div:nth-of-type(2)]:bg-tertiary [&>div:nth-of-type(2)]:rounded-t-2xl [&_#footer]:p-0 [&_#footer]:relative [&>div:last-of-type]:border-t",
                views: "h-full max-h-[96vh] [&>div:first-of-type]:pb-3 [&>div:first-of-type]:border-b [&>div:first-of-type]:bg-tertiary [&>div:first-of-type]:rounded-t-2xl [&>div:last-of-type]:border-t",
                "save-view": "[&>div:nth-of-type(2)]:pt-6",
                "task-creation":
                    "h-screen max-h-[90vh] [&>div]:pt-0 [&>div:first-of-type]:pt-6 [&_#footer]:pt-4 [&>div:first-of-type]:pb-4 [&>div:last-of-type]:pb-0 [&_#footer]:pb-4 [&>div]:border-b [&>div:last-of-type]:border-b-0 [&>div:first-of-type]:bg-secondary",
                "task-action":
                    "h-screen max-h-[90vh] [&>div]:pt-0 [&>div:first-of-type]:py-4 [&>div:last-of-type]:pt-4 [&>div]:border-b [&>div:last-of-type]:border-b-0 [&>div:first-of-type]:bg-secondary [&>div:first-of-type]:rounded-t-2xl",
                "action-log":
                    "[&>div:first-of-type]:pt-6 [&>div]:pb-4 [&>div:first-of-type]:pb-5 [&>div:first-of-type]:bg-secondary [&>div:first-of-type]:border-b [&>div:first-of-type]:rounded-t-2xl",
                upgrade: "[&>div:first-of-type]:!p-0",
                share: "[&>div:last-of-type]:pb-5",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const titleVariants = cva(
    "text-xl/normal font-semibold text-primary transition-font ease-in duration-200 truncate",
    {
        variants: {
            variant: {
                default: "",
                filters_from: "text-xl/normal font-semibold text-primary",
                filters_to:
                    "text-xl/normal scale-[0.8] -translate-x-[10%] font-medium text-tertiary",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const descriptionVariants = cva(
    "text-base font-medium text-tertiary transition-font ease-out duration-300",
    {
        variants: {
            variant: {
                default: "",
                slideshow: "text-sm",
                filters_from:
                    "text-xl/normal scale-[0.8] -translate-y-1 -translate-x-[10%] font-medium text-tertiary whitespace-nowrap",
                filters_to:
                    "text-xl/normal -translate-y-1 font-semibold text-primary",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const closeVariants = cva("absolute top-2 right-3 p-2", {
    variants: {
        variant: {
            default: "",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
